import { API_METHODS } from "../../constant";
export const personPrefDataApi = (
  _getAll,
  _get,
  _update,
  _create,
  _delete,
  paramsIn
) => {
  return {
    [API_METHODS.GET_PREF_DATA]: () => {
      let urlReq = `/Subject/${paramsIn.PersonId}/Pref/${paramsIn.id}`;
      return _get(urlReq); 
    },
    [API_METHODS.GET_ALL_PREF_DATA]: () => {
      let urlReq = `/Subject/${paramsIn.PersonId}/Pref`;
      return _getAll(urlReq); 
    },
    [API_METHODS.UPDATE_PREF_DATA]: () => {
      let urlReq = `/Subject/${paramsIn.PersonId}/Pref`;
      return _update(urlReq);
    },
    [API_METHODS.CREATE_PREF_DATA]: () => {
      let urlReq = `/Subject/${paramsIn.PersonId}/Pref`;
      return _create(urlReq);
    },
    [API_METHODS.DELETE_PREF_DATA]: () => {
      let urlReq = `/Subject/${paramsIn.PersonId}/Pref/${paramsIn.PrefId}`;
      return _delete(urlReq);
    }
  };
};
